import Vue from 'vue'
import Router from 'vue-router'
import indexPanel from '../components/indexPanel'
import aboutUs from '../components/aboutUs/aboutUs'
import solution from '../components/solution/solution'
import solutionDetail from '../components/solution/solutionDetail'
import technicalService from '../components/technicalService/technicalService'
import indexContent from '../components/indexContent/indexContent'
import trends from '../components/trends/trends'
import trendDetail from '../components/trends/trendDetail'
import employs from '../components/employs/employs'
import contact from '../components/contact/contact'
import mobileindex from '../components/Mobile/index'
import mobile from '../components/Mobile/mobie'
import mobileSolutionDetail from '../components/Mobile/mobileSolutionDetail/mobileSolutionDetail'
import mobileEmploys from '../components/Mobile/mobileEmploys/mobileEmploys'
import mobileNews from '../components/Mobile/mobileNews/mobileNews'
import mobileNewsDetail from '../components/Mobile/mobileNews/mobileNewsDetail'
import mobileNewsMore from '../components/Mobile/mobileNews/mobileNewsMore'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: indexPanel,
      children:[
        {path:'/about', name:'about', component:aboutUs},
        {path:'', name:'indexContent', component:indexContent},
        {path:'/solution', name:'solution', component:solution},
        {path:'/solutionDetail', name:'solutionDetail', component:solutionDetail},
        {path:'/technicalService', name:'technicalService', component:technicalService},
        {path:'/trends', name:'trends', component:trends},
        {path:'/trendDetail', name:'trendDetail', component:trendDetail},
        {path:'/employs', name:'employs', component:employs},
        {path:'/contact', name:'contact', component:contact},
      ]
    },
    {
      path: '/mobile',
      component: mobileindex,
      children: [
        {path:'', name:'mobile', component:mobile},
        {path:'/mobileSolutionDetail', name:'mobileSolutionDetail', component:mobileSolutionDetail},
        {path:'/mobileEmploys', name:'mobileEmploys', component:mobileEmploys},
        {path:'/mobileNews', name:'mobileNews', component:mobileNews},
        {path:'/mobileNewsDetail', name:'mobileNewsDetail', component:mobileNewsDetail},
        {path:'/mobileNewsMore', name:'mobileNewsMore', component:mobileNewsMore},
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js